export default __webpack_public_path__ + "static/media/HISTORY_REMIX.cccd3052.svg";